import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

import { get } from 'lodash';

/*************************************************************/

/**
 * @type {class}
 * @desc memberAddEditAddress defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { memberAddEditAddressService } from 'services/memberAddEditAddress';
 *
 * // create service instance and send/cancel request
 * const memberAddEditAddressService = new memberAddEditAddressService();
 * const result = await memberAddEditAddressService.fetchData( '<user-id>' ); // fetch data
 * memberAddEditAddressService.cancel(); // cancel an active request
 */
export class MemberAddEditAddressService extends HttpService {

    // fetch form data
    async fetchAddEditAddressForm( { url, data } ) {
        
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            const fields = get( response, 'body.component.structure.fields', {} );
            const actions = get( response, 'body.component.structure.actions', [] );
            const values = get( response, 'body.component.data', [] );
            const addTitle = get( response, 'body.component.structure.title', [] );
            const editTitle = get( response, 'body.component.structure.editTitle', [] );
            const addressSelectionConfig = get( response, 'body.component.structure.addressSelectionConfig', {} );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    fields,
                    actions,
                    values,
                    addTitle,
                    editTitle,
                    addressSelectionConfig
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // get the valid address
    async fetchValidAddresses( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: {
                    context: {},
                    data
                }
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...get( response, 'body.component.data.state', {} ),
                    ...get( response, 'body.component.data.options', {} ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
